import { dataProps } from './properties'

export const setGiftCardList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setGiftCardData = (state, payload) => {
    state.props = payload.response    
} 

export const resetGiftCardData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const setGiftCardAutocompleteList = (state, payload) => {
    state.autocomplete_list = payload
}


// WEBPACK FOOTER //
// ./src/store/modules/giftCard/mutations.js